// extracted by mini-css-extract-plugin
export default {"board":"Board_board__kV1iv","row":"Board_row__JJQiD"};